import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'errorMessage',
  standalone: true,
})
export class ErrorMessagePipe implements PipeTransform {
  transform(errorName: string, error: any): unknown {
    let msg = '';

    switch (errorName.toLowerCase()) {
      case 'notnull':
        msg = 'This field is required';
        break;
      case 'required':
        msg = 'This field is required';
        break;
      case 'pattern':
        msg = 'Invalid format. Must match: ' + error.requiredPattern;
        break;
      case 'maxlength':
        msg = 'Value too long. Max length: ' + error.requiredLength;
        break;
      case 'minlength':
        msg = 'Value too short. Min length: ' + error.requiredLength;
        break;
      case 'email':
        msg = 'Email address is not valid';
        break;
      case 'unique':
        msg = 'Entry must be unique';
        break;
      case 'emailtaken':
        msg = 'This email address is already in use';
        break;
      case 'nametaken':
        msg = 'This name is already in use';
        break;
      case 'age':
        msg = 'Age is invalid. ' + error.type + ' age: ' + error.required + ', actual: ' + error.actual;
        break;
      case 'max':
        msg = 'Maximum allowed is ' + (error?.max ?? error?.required ?? '');
        break;
      case 'min':
        msg = 'Minimum allowed is ' + (error?.min ?? error?.required ?? '');
        break;
      default:
        // If error is a string, use it directly
        if (typeof error === 'string') {
          msg = error;
        }
        // If errorName itself looks like a message (contains spaces or is long), use it
        else if (errorName.includes(' ') || errorName.length > 30) {
          msg = errorName;
        }
        else {
          console.log('Unhandled error:', errorName, error);
        }
        break;
    }
    return msg;
  }
}
